// extracted by mini-css-extract-plugin
module.exports = {"langselector":"LangSelector_langselector__5eOw7","lang":"LangSelector_lang__xdCRh","active":"LangSelector_active__9bCWz"};